import React from 'react';
import communityData from '../../data/community-events.json';

const past = communityData.past.filter(p => p.show !== false);

export default function PastEvents() {
    return (
        <section className="ce-past">
            <style>{`
                .ce-past {
                    background: var(--eventflow-black);
                    padding: 80px 0 100px;
                    position: relative; overflow: hidden;
                    border-top: 1px solid rgba(255,255,255,0.05);
                }
                .ce-past::before {
                    content: '';
                    position: absolute; inset: 0;
                    background: radial-gradient(ellipse at 30% 50%, rgba(var(--eventflow-base-rgb),0.06) 0%, transparent 55%);
                    pointer-events: none;
                }
                .ce-past-grid {
                    display: grid;
                    grid-template-columns: repeat(3,1fr);
                    gap: 20px;
                    margin-top: 48px;
                }
                .ce-past-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 14px; overflow: hidden;
                    transition: all 0.3s;
                }
                .ce-past-card:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.25);
                    transform: translateY(-4px);
                    box-shadow: 0 16px 40px rgba(0,0,0,0.3);
                }
                .ce-past-card__img {
                    height: 180px; overflow: hidden; position: relative;
                }
                .ce-past-card__img img {
                    width: 100%; height: 100%; object-fit: cover;
                    filter: brightness(0.75) saturate(0.8);
                    transition: filter 0.4s, transform 0.4s;
                }
                .ce-past-card:hover .ce-past-card__img img {
                    filter: brightness(0.9) saturate(1.0);
                    transform: scale(1.05);
                }
                .ce-past-card__img-placeholder {
                    width: 100%; height: 100%;
                    background: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .ce-past-card__img-placeholder span {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                }
                .ce-past-card__img-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(to top, rgba(4,0,10,0.8) 0%, transparent 60%);
                }
                .ce-past-card__attendees {
                    position: absolute; bottom: 12px; right: 12px;
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    color: #fff;
                    background: rgba(var(--eventflow-base-rgb),0.8);
                    border-radius: 20px; padding: 3px 10px;
                    backdrop-filter: blur(4px);
                }
                .ce-past-card__body { padding: 18px 20px 20px; }
                .ce-past-card__date {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 600;
                    letter-spacing: 1.5px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 6px;
                }
                .ce-past-card__title {
                    font-family: var(--eventflow-font);
                    font-size: 15px; font-weight: 700;
                    color: #fff; margin-bottom: 8px; line-height: 1.3;
                }
                .ce-past-card__highlight {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.4);
                    line-height: 1.6; margin: 0;
                }
                /* CTA strip */
                .ce-past-cta {
                    margin-top: 48px;
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 14px; padding: 32px 36px;
                    display: flex; align-items: center;
                    justify-content: space-between; gap: 20px;
                    flex-wrap: wrap;
                }
                .ce-past-cta h4 {
                    font-family: var(--eventflow-font);
                    font-size: 20px; font-weight: 800; color: #fff; margin-bottom: 4px;
                }
                .ce-past-cta p {
                    font-size: 13px; color: rgba(255,255,255,0.4); margin: 0;
                }
                @media (max-width: 991px) { .ce-past-grid { grid-template-columns: repeat(2,1fr); } }
                @media (max-width: 576px)  {
                    .ce-past-grid { grid-template-columns: 1fr; }
                    .ce-past-cta { padding: 24px 20px; }
                }
            `}</style>

            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                    <div className="ce-sec-tag" style={{justifyContent:'center'}}>{communityData.pastSection.tag}</div>
                    <h2 className="ce-sec-title" style={{textAlign:'center'}}>{communityData.pastSection.titleStart} <span>{communityData.pastSection.titleAccent}</span></h2>
                    <p style={{color:'rgba(255,255,255,0.45)',fontSize:'15px',maxWidth:'500px',margin:'0 auto'}}>
                        {communityData.pastSection.subtitle}
                    </p>
                </div>

                <div className="ce-past-grid wow fadeInUp" data-wow-delay="150ms">
                    {past.map((p, i) => (
                        <div className="ce-past-card" key={i}>
                            <div className="ce-past-card__img">
                                {p.img ? (
                                    <img src={p.img} alt={p.title} />
                                ) : (
                                    <div className="ce-past-card__img-placeholder">
                                        <span>Your Image</span>
                                    </div>
                                )}
                                <div className="ce-past-card__img-overlay" />
                                <span className="ce-past-card__attendees"><i className="fa fa-users" style={{marginRight:'4px'}} />{p.attendees} attended</span>
                            </div>
                            <div className="ce-past-card__body">
                                <div className="ce-past-card__date">{p.date}</div>
                                <div className="ce-past-card__title">{p.title}</div>
                                <p className="ce-past-card__highlight">{p.highlight}</p>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </section>
    );
}
